import axios from "axios"
import { EmployeeDocumentCreateInterface, EmployeeDocumentPatchInterface } from "../redux/employee_documents/employee_documents.type"
/**
 * Get all documents
 *
 * @param uuid
 * @param clientUuid
 * @param employeeUuid
 */

async function getEmployeeDocumentsApi(uuid: string, clientUuid: string, employeeUuid: string | undefined){
    return axios({
        method: "GET",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees/${employeeUuid}/documents`
    })
}

/**
 * Create new client document
 *
 * @param uuid
 * @param clientUuid
 * @param employeeUuid
 * @param data
 */

async function postEmployeeDocumentApi(uuid: string, clientUuid: string, employeeUuid: string | undefined, data: EmployeeDocumentCreateInterface){
    return axios({
        method:"POST",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees/${employeeUuid}/documents`,
        // data: {data}
        data
    })
}

/**
 * Get details of the selected document
 *
 * @param uuid
 * @param clientUuid
 * @param employeeUuid
 * @param employeeDocumentUuid
 */

async function getEmployeeDocumentApi(uuid: string, clientUuid: string, employeeUuid: string, employeeDocumentUuid: string){
    return axios({
        method:"GET",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees/${employeeUuid}/documents/${employeeDocumentUuid}`
    })
}

/**
 * Update selected document
 *
 * @param uuid
 * @param clientUuid
 * @param employeeUuid
 * @param employeeDocumentUuid
 * @param data
 */

async function patchEmployeeDocumentApi(uuid: string, clientUuid: string, employeeUuid: string | undefined, employeeDocumentUuid: string, data: EmployeeDocumentPatchInterface){
    return axios({
        method:"PATCH",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees/${employeeUuid}/documents/${employeeDocumentUuid}`,
        data
    })
}

/**
 * Delete selected document
 *
 * @param uuid
 * @param clientUuid
 * @param employeeUuid
 * @param employeeDocumentUuid
 */

async function deleteEmployeeDocumentApi(uuid: string, clientUuid: string, employeeUuid: string | undefined, employeeDocumentUuid: string){
    return axios({
        method:"DELETE",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees/${employeeUuid}/documents/${employeeDocumentUuid}`,
    })
}


export {
    deleteEmployeeDocumentApi,
    getEmployeeDocumentApi,
    getEmployeeDocumentsApi,
    patchEmployeeDocumentApi,
    postEmployeeDocumentApi
}